import React from 'react';

const HtmlParser = ({ htmlString }) => {
  return (
      <div className='email-modal' dangerouslySetInnerHTML={{ __html: htmlString }} />
  );
};

export default HtmlParser;